document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("mr-point")) {
    class MrPoint extends HTMLElement {
      constructor() {
        super();

        this.APPLY_USE_POINT_EVENT = "mrpoint:apply-use-point";
        this.RESET_USE_POINT_EVENT = "mrpoint:reset-use-point";

        // サーバー側に記載されてるエラーメッセージもあるので、いったん静的に記載しておく。後追いで動的に値を設定できる形にできないか検討
        this.emptyErrorMessage = "ポイントを入力してください。";

        this.customerId = this.dataset.customerId;
        const customerTagStr = this.dataset.customerTags;
        this.customerTags = customerTagStr ? customerTagStr.split(",") : [];
        this.totalSpent = this.dataset.totalSpent
          ? Number(this.dataset.totalSpent)
          : 0;
        this.blockType = this.dataset.blockType;
        this.elContainer = this.querySelector(".js-container");
        this.elCurrentPointValue = this.querySelector(
          ".js-current-point-value",
        );
        this.elRankValue = this.querySelector(".js-rank-value");
        this.elUseButton = this.querySelector(".js-use-button");
        this.elResetButton = this.querySelector(".js-reset-button");
        this.elUsePoint = this.querySelector(".js-use-point");
        this.elDiscountValue = this.querySelector(".js-point-discount-value");
        this.elApplyPointValue = this.querySelector(".js-apply-point-value");
        this.elUsePointInput = this.querySelector(".js-use-point-input");
        this.elError = this.querySelector(".js-error");

        if (this.blockType === "embed") {
          this.initFormEmbed();
        }

        if (this.blockType === "section") {
          this.initFormSection();
        }
      }

      initFormSection() {
        this.initContent();
        this.setUsePointEvent();
        if (this.elResetButton) {
          this.setResetEvent();
        }
      }

      initFormEmbed() {
        const elHeader = this.querySelector(".js-header");
        elHeader.addEventListener("click", () => {
          if (!this.elContainer.classList.contains("is-open")) {
            this.elContainer.classList.add("is-open");
            this.elContainer.classList.add("is-loading");

            this.initContent();
          } else {
            this.elContainer.classList.remove("is-open");
          }
        });

        this.setUsePointEvent();
        if (this.elResetButton) {
          this.setResetEvent();
        }
      }

      setUsePointEvent() {
        this.elUseButton.addEventListener("click", () => {
          const usePoint = this.elUsePointInput.value;
          if (!usePoint) {
            this.elError.innerHTML = this.emptyErrorMessage;
            return;
          }
          this.elUsePoint.classList.add("is-apply");
          this.elContainer.classList.add("is-loading");
          this.elApplyPointValue.innerHTML = usePoint.toLocaleString();
          this.elError.innerHTML = "";

          const requestJson = {
            secret_key: this.secretKey,
            usepoint: usePoint,
            customer_id: this.customerId,
          };
          this.commonajax(
            "/apps/mrpoint/coupon_generate",
            requestJson,
            this.applyDiscount.bind(this),
            null,
          );
        });
      }

      initContent() {
        const requestJson = {
          secret_key: this.secretKey,
          customer_id: this.customerId,
          tags: JSON.stringify(this.customerTags),
          total_spent: this.totalSpent,
        };

        this.commonajax(
          "/apps/mrpoint/coupon_generate",
          requestJson,
          this.renderPointContent.bind(this),
          null,
        );

        // sessionStorageに使用ポイントのデータがある場合は、表示を切り替える
        this.renderApplyPoint();
      }

      renderPointContent(data) {
        if (data.err) {
          const timeoutMessage = "接続エラー。ページを更新してください。";
          this.renderError(data, timeoutMessage);
        } else {
          this.elContainer.classList.remove("is-loading");
          this.elCurrentPointValue.innerHTML = data.point.toLocaleString();
          if (this.elRankValue) {
            this.elRankValue.innerHTML = data.rank_name.toLocaleString();
          }
        }
      }

      applyDiscount(data, param) {
        if (data.err) {
          const timeoutMessage = "接続エラー。再度お試しください。";
          this.renderError(data, timeoutMessage);
        } else {
          // クーポンを適用後、セッションストレージにデータを追加し表示を切り替える。
          fetch(`/discount/${data.coupon_code}`)
            .then((json) => {
              sessionStorage.setItem("mrpointUsePoint", data.usepoint);
              sessionStorage.setItem("mrpointAppliedAt", new Date().getTime());

              this.renderApplyPoint(data.usepoint);
              const detail = {
                point: data.usepoint,
                couponCode: data.coupon_code,
              };
              this.triggerEvent(this.APPLY_USE_POINT_EVENT, detail);
            })
            .catch((err) => {});
        }
      }

      renderApplyPoint(applyPoint = null) {
        let applyPointValue = applyPoint;
        let pointAppliedAt;
        if (!applyPoint) {
          applyPointValue = sessionStorage.getItem("mrpointUsePoint");
          pointAppliedAt = sessionStorage.getItem("mrpointAppliedAt");
        }

        // 有効期限チェック。有効期限を超えていた場合は、sessionStorageのデータを削除し処理終了
        if (applyPointValue && pointAppliedAt) {
          const now = new Date().getTime();
          const elapsedTime = now - Number(pointAppliedAt);
          const validPeriod = 24 * 60 * 60 * 1000; // 24時間
          if (elapsedTime > validPeriod) {
            sessionStorage.removeItem("mrpointUsePoint");
            sessionStorage.removeItem("mrpointAppliedAt");
            return;
          }
        }

        // 表示切り替え
        if (applyPointValue) {
          this.elDiscountValue.textContent = applyPointValue;
          this.elUseButton.textContent =
            this.elUseButton.dataset.updatePointText;
          this.elUsePointInput.value = "";
          this.elContainer.classList.remove("is-loading");
          this.elUsePoint.classList.remove("is-apply");
          this.elUsePoint.classList.add("is-discount");
        }
      }

      renderError(data, timioutMessage) {
        this.elContainer.classList.remove("is-loading");
        this.elUsePoint.classList.remove("is-apply");
        const message = data.err == "TIMEOUT" ? timioutMessage : data.err;
        this.elError.innerHTML = message;
      }

      setResetEvent() {
        this.elResetButton.addEventListener("click", () => {
          this.elContainer.classList.add("is-loading");

          this.commonajax(
            "/apps/mrpoint/reset_use_point",
            {},
            this.resetDiscount.bind(this),
            null,
          );
        });
      }

      resetDiscount() {
        sessionStorage.removeItem("mrpointUsePoint");
        sessionStorage.removeItem("mrpointAppliedAt");
        this.elDiscountValue.textContent = "";
        this.elUseButton.textContent = this.elUseButton.dataset.usePointText;
        this.elUsePointInput.value = "";
        this.elContainer.classList.remove("is-loading");
        this.elUsePoint.classList.remove("is-discount");

        this.triggerEvent(this.RESET_USE_POINT_EVENT);
      }

      //-----------------------------------------------
      // jquery使わない式のajax
      // @param url   リクエスト先
      // @param requestJson リクエストデータ(json形式)
      // @param callback 取得後実行処理
      // @param cbparam 取得後実行処理に対する引数
      //-----------------------------------------------
      commonajax(url, requestJson, callback, cbparam) {
        const controller = new AbortController();
        const timeout = setTimeout(() => {
          controller.abort();
        }, 10000);

        fetch(url, {
          method: "POST",
          body: JSON.stringify(requestJson),
          headers: { "Content-Type": "application/json; charset=utf-8" },
          signal: controller.signal,
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            if (callback) callback(data, cbparam);
          })
          .catch(function (err) {
            if (err.name == "AbortError") {
              if (callback) callback({ err: "TIMEOUT" }, null);
            } else {
              if (callback) callback({ err: "ERROR" }, null);
            }
          });
      }

      triggerEvent(eventName, detail = {}) {
        const event = new CustomEvent(eventName, { detail });
        document.dispatchEvent(event);
      }
    }

    customElements.define("mr-point", MrPoint);
  }

  if (!customElements.get("mr-point-cart")) {
    class MrPointCart extends HTMLElement {
      constructor() {
        super();

        this.blockType = this.dataset.blockType;
        this.taxesIncluded =
          this.dataset.taxesIncluded === "true" ? true : false;
        this.taxRate = this.dataset.taxRate
          ? parseFloat(this.dataset.taxRate)
          : null;
        this.pointRate = this.dataset.pointRate
          ? parseFloat(this.dataset.pointRate)
          : null;

        this.cartPoint = 0;

        // Set cart item point data
        this.cartItemPoint = [];
        this.setCartItemPoint();

        // Show award point
        if (this.blockType === "award-point") {
          this.initAwardPoint();
        }

        // Set cart update event listener
        document.addEventListener("mrpoint:update-award-point", async (e) => {
          let cartItems = e.detail?.cartItems;
          if (!cartItems) {
            cartItems = await this.getCartItems();
          }

          this.calculatePoint(cartItems);
          this.setAwardPoint();
        });
      }

      async initAwardPoint() {
        const cartItems = await this.getCartItems();

        this.calculatePoint(cartItems);
        this.setAwardPoint();
      }

      async getCartItems() {
        try {
          const response = await fetch(`/cart.json`, {
            method: "GET",
          });
          if (response.status !== 200) {
            throw new Error("Failed to get cart data");
          }
          const cartData = await response.json();
          if (!cartData.items) {
            throw new Error("Failed to get cart items");
          }

          return cartData.items;
        } catch (err) {
          console.error(err);
        }
      }

      setCartItemPoint() {
        const elCartItems = this.querySelectorAll(".js-cart-item");

        for (const elItem of elCartItems) {
          const lineitemKey = elItem.dataset.lineitemKey;
          const productId = elItem.dataset.productId;
          const variantId = elItem.dataset.variantId;
          const pointRate = parseFloat(elItem.dataset.pointRate);
          this.cartItemPoint.push({
            lineitemKey: lineitemKey,
            productId: productId,
            variantId: variantId,
            pointRate: pointRate,
          });
        }
      }

      calculatePoint(cartItems) {
        let totalPoint = 0;
        for (const cartItem of cartItems) {
          // Shopifyの仕様で日本円だと100掛けの金額で返されるため調整。
          let price = Number(cartItem.final_price) / 100;
          if (this.taxesIncluded) {
            price = Math.round(price / (1 + this.taxRate));
          }

          // カート更新時にkeyが変わる事象があったため、keyは使用せずproductIdとvariantIdの一致で対象商品を特定する。
          const targetItem = this.cartItemPoint.find(
            (item) =>
              item.productId === String(cartItem.product_id) &&
              item.variantId === String(cartItem.variant_id),
          );
          totalPoint += price * cartItem.quantity * targetItem.pointRate;
        }

        this.cartPoint = Math.floor(totalPoint);
      }

      setAwardPoint() {
        this.elAwardPointValue =
          this.elAwardPointValue || this.querySelector(".js-award-point-value");
        this.elAwardPointValue.textContent = this.cartPoint;
      }
    }

    customElements.define("mr-point-cart", MrPointCart);
  }
});